import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Layout from '@/components/Layout';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' as const } },
};

const stagger = {
  visible: { transition: { staggerChildren: 0.15 } },
};

const triggerClass = "text-xl text-black font-bold hover:no-underline hover:text-[#F97116] gap-4 text-right justify-end flex-row-reverse";
const contentClass = "text-black/75 text-lg leading-relaxed text-right";
const itemClass = "bg-white rounded-3xl px-8 py-2 border-none";

const faqSections = [
  {
    title: 'כללי',
    items: [
      { q: 'מה זה Bracket Run?', a: 'תחרות ניחושים לפלייאוף ה-NBA בין חברים. מנחשים תוצאות סדרות, ממלאים ברקט, ומתחרים על המקום הראשון בלידרבורד.' },
      { q: 'כמה זה עולה?', a: 'חינם לגמרי. אין מנוי, אין פרסומות.' },
      { q: 'איך נרשמים?', a: 'כניסה עם Google, או עם קוד למייל ויצירת סיסמה. אחרי הכניסה בוחרים שם תצוגה ואווטאר.' },
      { q: 'אפשר להתקין את זה כאפליקציה?', a: 'כן, מכל מכשיר. בזמן הגלישה יקפוץ קישור להתקנה בדפדפן.' },
    ],
  },
  {
    title: 'קבוצות',
    items: [
      { q: 'איך מצטרפים לקבוצה?', a: 'דרך לינק הזמנה שמקבלים מהקומישינר. לוחצים על הלינק, נרשמים, ומגיעים ישר לקבוצה.' },
      { q: 'אפשר להיות בכמה קבוצות?', a: 'כן. אפשר להחליף בין קבוצות דרך התפריט בהדר.' },
      { q: 'מה זה קומישינר?', a: 'מנהל הקבוצה. יכול להזמין ולהסיר חברים, לערוך הימורים, ולשלוח תזכורות.' },
    ],
  },
  {
    title: 'ניקוד: הימורי סדרות',
    items: [
      { q: 'איך ההימורים עובדים?', a: 'בוחרים מנצח + תוצאה מדויקת (למשל "תאנדר 4-2"). ככל שהתוצאה פחות צפויה לפי הסיכויים, יותר נקודות.' },
      { q: 'כמה נקודות מקבלים?', a: 'ניחוש מנצח בלבד: 2 נקודות. ניחוש תוצאה מדויקת: 2 + בונוס (בין 2 ל-12, לפי הסיכויים). מקסימום לסדרה: 14 נקודות.' },
      { q: 'מאיפה הסיכויים?', a: 'מתעדכנים בלייב מאתרי סוכנויות ההימורים הגדולות בארה"ב, מנורמלים ומותאמים למערכת הניקוד של האפליקציה.' },
      { q: 'עד מתי אפשר להמר?', a: 'עד הדדליין של כל סדרה (מוצג בטיימר). אחרי זה ההימור ננעל.' },
      { q: 'אפשר לשנות הימור?', a: 'כן, עד הדדליין. אחרי זה לא.' },
    ],
  },
  {
    title: 'GLOBAL BRACKET',
    items: [
      { q: 'מה זה GLOBAL BRACKET?', a: 'ניחוש של כל הפלייאוף מראש, 15 סדרות מסיבוב 1 ועד הגמר.' },
      { q: 'מה ההבדל מהימורי הסדרות?', a: 'הברקט הוא משחק נפרד עם שיטת ניקוד שונה. יש טבלה גלובלית לכל משתתפי האפליקציה שבה אפשר לראות את הדירוג לפי שיטת ניקוד הברקט: 200 נקודות על מנצח נכון, 400 על תוצאה מדויקת.' },
      { q: 'אז הברקט לא משפיע על הקבוצה שלי?', a: 'לגמרי. תחרות גלובלית שאינה קשורה לקבוצות הפרטיות.' },
      { q: 'עד מתי ממלאים ברקט?', a: 'עד 18 באפריל (תחילת הפלייאוף). אחרי זה הברקטים ננעלים ואפשר לראות את הברקטים של כולם.' },
    ],
  },
  {
    title: 'ניקוד: הימורי צד',
    items: [
      { q: 'מה זה הימורי צד?', a: '10 שאלות אוטומטיות לאורך הטורניר, על שחקנים, לא על תוצאות סדרות. למשל: "מי יוביל בנקודות למשחק בסיבוב 1?"' },
      { q: 'איך הניקוד?', a: 'כל הימור צד שווה מספר נקודות קבוע (מוצג על כל שאלה). סה"כ הימורי צד שווים כ-21% מסך הנקודות.' },
      { q: 'מה קורה אם לא עניתי על כולם?', a: 'מפסידים את הנקודות של מה שלא מילאתם. אין עונש נוסף.' },
    ],
  },
  {
    title: 'לקומישינרים',
    items: [
      { q: 'איך יוצרים קבוצה?', a: 'אחרי הרשמה, "צור קבוצה חדשה", בוחרים שם, מקבלים לינק הזמנה.' },
      { q: 'איך מזמינים חברים?', a: 'כפתור שיתוף בעמוד הקבוצה, שולח לינק בוואטסאפ או מעתיק ללוח.' },
      { q: 'מה אני צריך לעשות כקומישינר?', a: 'כמעט כלום. הכל אוטומטי: סיכויים, ניקוד, לידרבורד. אתה רק מזמין חברים ושולח תזכורות אם צריך.' },
      { q: 'אפשר לערוך הימור של מישהו?', a: 'כן, דרך "God Mode" בתפריט הניהול. מיועד למקרים חריגים.' },
    ],
  },
];

let globalIndex = 0;

const FaqPage = () => {
  globalIndex = 0;

  return (
    <Layout>
      <div className="font-leon min-h-screen bg-[#15191E] text-[#FEFEFE]" dir="rtl">
        <div className="container mx-auto px-4 py-10 max-w-2xl">
          <Link to="/" className="text-sm text-white/60 hover:text-[#F97116] transition-colors flex items-center gap-1 mb-6 min-h-[44px]">
            <ArrowRight className="w-4 h-4 rotate-180" /> חזרה
          </Link>

          <motion.h1
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            className="text-3xl sm:text-4xl font-black mb-10 text-center"
          >
            שאלות ותשובות
          </motion.h1>

          <motion.div
            initial="hidden"
            animate="visible"
            variants={stagger}
            className="space-y-10"
          >
            {faqSections.map((section) => (
              <motion.div key={section.title} variants={fadeUp}>
                <h2 className="text-2xl font-bold mb-4 text-[#F97116]">{section.title}</h2>
                <Accordion type="single" collapsible className="w-full space-y-3">
                  {section.items.map(({ q, a }) => {
                    const value = `faq-${++globalIndex}`;
                    return (
                      <AccordionItem key={value} value={value} className={itemClass}>
                        <AccordionTrigger className={triggerClass}>
                          {q}
                        </AccordionTrigger>
                        <AccordionContent className={contentClass}>
                          {a}
                        </AccordionContent>
                      </AccordionItem>
                    );
                  })}
                </Accordion>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </Layout>
  );
};

export default FaqPage;
